import { render, staticRenderFns } from "./entry.vue?vue&type=template&id=0b1ba786&"
import script from "./entry.vue?vue&type=script&lang=js&"
export * from "./entry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b1ba786')) {
      api.createRecord('0b1ba786', component.options)
    } else {
      api.reload('0b1ba786', component.options)
    }
    module.hot.accept("./entry.vue?vue&type=template&id=0b1ba786&", function () {
      api.rerender('0b1ba786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/pages/peopleVerify/components/entry.vue"
export default component.exports